/* eslint-disable react/jsx-boolean-value */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import {useState, useEffect} from 'react';
import './Pagination.scss';
import ReactPaginate from 'react-paginate';
import Util from '../util/Util';
import Analytics from '../util/Analytics';
import Locale from '../util/Locale';

export default function Pagination(props) {
    const [mobile, setMobile] = useState(Util.isMobile());

    useEffect(() => {
        window.addEventListener('resize', () => {
            setMobile(Util.isMobile());
        });
    });

    function isExtendedPagination() {
        return props.page > 3 && props.page < props.maxPages - 4 ? 'extended' : '';
    }

    function getSizeClass() {
        if (props.maxPages > 99) {
            return 'p8n-large';
        }
        if (props.maxPages > 9) {
            return 'p8n-medium';
        }
        return 'p8n-small';
    }

    function getRange() {
        return mobile ? 2 : 4;
    }

    function renderSizeSelection() {
        return (
            <div className="advanced-search">
                <nsemble-select
                    value={props.pageSize}
                    onInput={event => {
                        Analytics.trackEvent('View', `Pagesize : ${event.target.value}`);
                        return props.setPageSize && props.setPageSize(event.target.value);
                    }}
                >
                    <option value="25">25 {Locale.getText('PER_PAGE')}</option>
                    <option value="50">50 {Locale.getText('PER_PAGE')}</option>
                    <option value="100">100 {Locale.getText('PER_PAGE')}</option>
                </nsemble-select>
            </div>
        );
    }

    function renderPagingInfo() {
        return (
            <div className="amount-shown">
                {`${Locale.getText('SHOWING')} ${props.page * props.pageSize + 1} - ${
                    (props.page + 1) * props.pageSize > props.totalAssets
                        ? `${props.totalAssets}`
                        : `${(props.page + 1) * props.pageSize}`
                } of ${props.totalAssets}`}
            </div>
        );
    }

    return (
        props.totalAssets > 0 && (
            <div
                className={`pagination ${
                    'condensed' in props && 'condensed'
                } ${getSizeClass()} ${isExtendedPagination()}`}
            >
                {!('condensed' in props) && renderSizeSelection()}
                {!('condensed' in props) && renderPagingInfo()}
                {props.maxPages > 1 && (
                    <ReactPaginate
                        disableInitialCallback={true}
                        forcePage={props.page}
                        onPageChange={event => props.setPage && props.setPage(event.selected)}
                        pageRangeDisplayed={getRange()}
                        marginPagesDisplayed={1}
                        pageCount={props.maxPages}
                        previousLabel={
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                                <g
                                    className="nc-icon-wrapper"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                >
                                    <polyline
                                        fill="none"
                                        strokeMiterlimit="10"
                                        points="17,2 7,12 17,22 "
                                        transform="translate(0, 0)"
                                    />
                                </g>
                            </svg>
                        }
                        nextLabel={
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                                <g
                                    className="nc-icon-wrapper"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                >
                                    <polyline
                                        fill="none"
                                        strokeMiterlimit="10"
                                        points="7,2 17,12 7,22 "
                                        transform="translate(0, 0)"
                                    />
                                </g>
                            </svg>
                        }
                        containerClassName="nsemble-pagination"
                        disabledClassName="disabled"
                    />
                )}
            </div>
        )
    );
}
